import parser from 'html-react-parser';
import React from 'react';
import { TbArrowUpRight } from 'react-icons/tb';
import { useSelector } from 'react-redux';
import { imageUrl } from '../../config/apiUrl';
import { mergeClass } from '../../utils/helpers';
import classes from './BlogCard.module.css';

const BlogCard = ({ data, onClick }) => {
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  return (
    <button className={mergeClass('btnWrapper', classes?.mainContainer)} onClick={onClick}>
      <div className={classes?.imageContainer}>
        <img alt="blog-card" src={imageUrl(data?.image)} />
      </div>
      <div className={classes?.detailContainer}>
        <div className={classes?.topContainer}>
          <h6>{data?.title?.[selectedLanguage]}</h6>
          <TbArrowUpRight size={34} />
        </div>
        <p>{parser(data?.description?.[selectedLanguage])}</p>
      </div>
    </button>
  );
};

export default BlogCard;
